import React, { useEffect, useState } from "react";
import { WifiOff, RefreshCw, CloudUpload } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/pages/crm/shared";
import { readQueue, onQueueChange, syncQueue } from "@/pages/crm/offline";

// Header pill: offline state + queued calls; replays the queue automatically when the signal returns.
export function OfflineStatus() {
  const [online, setOnline] = useState(navigator.onLine);
  const [q, setQ] = useState(readQueue());
  const [busy, setBusy] = useState(false);
  const run = async () => {
    const token = localStorage.getItem("rcrm_token");
    if (!token || readQueue().length === 0) return;
    setBusy(true);
    const r = await syncQueue(api(token));
    setBusy(false);
    if (r.synced) toast.success(`Back online — ${r.synced} offline call${r.synced === 1 ? "" : "s"} synced`);
    if (r.failed) toast.error(`${r.failed} offline entr${r.failed === 1 ? "y" : "ies"} could not be saved (lead changed) — please re-log`);
  };
  useEffect(() => {
    const on = () => { setOnline(true); run(); };
    const off = () => setOnline(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    const un = onQueueChange(setQ);
    run();
    const t = setInterval(() => navigator.onLine && run(), 45000);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); un(); clearInterval(t); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (online && q.length === 0) return null;
  return (
    <button data-testid="offline-status" onClick={run} title={online ? "Tap to sync now" : "No signal — calls are saved on this phone"}
      className={`inline-flex items-center gap-1.5 text-xs font-bold rounded-full px-2.5 py-1 ${online ? "bg-amber-100 text-amber-800" : "bg-[#1A1A2E] text-white"}`}>
      {!online ? <WifiOff size={13} /> : busy ? <RefreshCw size={13} className="animate-spin" /> : <CloudUpload size={13} />}
      {!online ? `Offline${q.length ? ` · ${q.length} saved` : ""}` : busy ? "Syncing…" : `${q.length} to sync`}
    </button>
  );
}
